enum Originators {
  Tab = 'TAB',
  Merchant = 'MERCHANT',
}

export default Originators;
